module.exports = __webpack_public_path__ + "static/storm_giant-4fbdbf72b8ed76b4c76e8885190bd7a5.jpg";